import { useState, useCallback } from 'react';
import { logError } from '../../../../../utils/logger';

export const usePOISelection = () => {
  const [showPOISelector, setShowPOISelector] = useState(false);
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [selectedFile, setSelectedFile] = useState(null);
  const [showFilePOIForm, setShowFilePOIForm] = useState(false);

  const handleMapClick = useCallback((e, mode) => {
    if (mode === 'selection') {
      const lat = e.latLng?.lat();
      const lng = e.latLng?.lng();
      
      if (!lat || !lng || typeof lat !== 'number' || typeof lng !== 'number' || isNaN(lat) || isNaN(lng)) {
        logError('Invalid coordinates from map click');
        return {
          error: 'Invalid location coordinates. Please try again.'
        };
      }
      
      if (selectedFile) {
        setSelectedLocation({ lat, lng });
        setShowFilePOIForm(true);
        return { resetMode: true };
      }

      setShowPOISelector(true);
      setSelectedLocation({ lat, lng });
    }
    return {};
  }, [selectedFile]);

  const resetSelection = useCallback(() => {
    setShowPOISelector(false);
    setSelectedLocation(null);
    setSelectedFile(null);
    setShowFilePOIForm(false);
  }, []);

  return {
    showPOISelector,
    selectedLocation,
    selectedFile,
    showFilePOIForm,
    handleMapClick,
    setSelectedFile,
    resetSelection,
    setShowFilePOIForm
  };
};